function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#020202;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M81.27,490.57c0,16.26,5.52,40.44,31.84,63.32,15.08,13.11,35.55,24.47,60.83,33.77,46.71,17.17,108,26.63,172.44,26.63s125.74-9.46,172.45-26.63c25.28-9.3,45.74-20.66,60.82-33.77C606,531,611.5,506.83,611.5,490.57V326.62h-1a72.9,72.9,0,0,0,1-12.13v-142h-3.9c-7.45-38.2-122-68.54-262.25-68.54-138,0-251.12,29.37-261.82,66.7H81.27V314.49A73.68,73.68,0,0,0,82,324.78h-.73Zm83-261.56c47.12,12.39,110.88,20,181.08,20,71.23,0,135.83-7.83,183.15-20.54V311.9c-3.54,4.5-17.76,15.88-51.41,26.16-36.18,11.06-82.6,17.15-130.71,17.15s-94.52-6.09-130.71-17.15c-33.65-10.28-47.86-21.66-51.4-26.16Zm0,178.81q4.71,1.94,9.67,3.76c46.71,17.17,108,26.63,172.44,26.63s125.74-9.46,172.45-26.63q4.95-1.83,9.67-3.76V488c-3.55,4.5-17.76,15.88-51.41,26.16-36.18,11.06-82.6,17.15-130.71,17.15s-94.52-6.09-130.71-17.15C182,503.86,167.81,492.48,164.27,488Z"
});

function SvgEarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.72ba73f4.svg";
export { ForwardRef as ReactComponent };